/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Share': {
    width: 18,
    height: 12,
    viewBox: '0 0 18 12',
    data: '<path fill="black" pid="1" d="M11.143 0L18 5.556l-6.857 5.555V8.222C10.778 8.204 4.419 7.992 0 12c1.768-5.65 7.323-8.108 11.143-9.111V0z"/>'
  }
})
